export const ROOMS_EVENTS = {
    ROOMS_FILTER_CHANGED: 'ROOMS_FILTER_CHANGED',
    ROOMS_PAGING_CHANGED: 'ROOMS_PAGING_CHANGED',
}
